interface TeamGroupTeamLabelDetails {
	category?: string | null;
	clubName?: string | null;
	country?: string | null;
}

export function formatTeamGroupClubOptionLabel(
	id: number,
	name: string,
	countryCode?: string | null,
): string {
	if (countryCode != null && countryCode !== "") {
		return `${name} (#${id}, ${countryCode})`;
	}

	return `${name} (#${id})`;
}

export function formatTeamGroupTeamOptionLabel(
	name: string,
	details: TeamGroupTeamLabelDetails = {},
): string {
	const parts: string[] = [];

	if (details.category != null && details.category !== "") {
		parts.push(details.category);
	}
	if (details.clubName != null && details.clubName !== "") {
		parts.push(details.clubName);
	}
	if (details.country != null && details.country !== "") {
		parts.push(details.country);
	}

	if (parts.length === 0) {
		return name;
	}

	return `${name} (${parts.join(", ")})`;
}
